const messages = {
	en: {
		addClient: "ADD ANOTHER CLIENT",
		back: "BACK",
		furtherAssistance:
			"If you need any further assistance, please reach out to:",
		header: "Onboarding in progress",
		logout: "LOGOUT",
		onboardingUrl: "onboarding@futureforex.co.za",
		paragraph1:
			"We are busy processing your registration and a member of our onboarding team will reach out to you shortly.",
		paragraph2:
			"Once your onboarding has been completed you will be notified via email and have full access to this dashboard.",
	},
};

export default messages;
